export default __webpack_public_path__ + "static/media/deeperInsightsColored.f3cc1b03.svg";